import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-policies',
  imports: [],
  templateUrl: './cookie-policies.component.html',
  styleUrl: './cookie-policies.component.css',
})
export class CookiePoliciesComponent {
constructor(private router: Router) {
  }
  

  goBack(): void {
    this.router.navigate([""]);
  }
}
